<template>
  <div class="input-form-wrap-row spacing-height input-box" :class="inputStyleClass">
    <div class="input-label">
      <span style="color:red" v-if="required">*</span>
      <span>{{ label }}</span>
    </div>
    <el-input-number id="num-align" class="input-form" :style="customStyle" :value="value" controls-position="right" :min="0" style="text-align: left;"
     @input="handleInput" size="small" :disabled="isEditServOrder=='1'" :step="step"/>
     <span class="suffix-text">{{ suffixText }}</span>
  </div>
</template>

<script>
  export default {
    props: {
      label: String,
      value: [String, Number],
      required: Boolean,
      customStyle: Object,
      isDisabled: Boolean,
      suffixText: String,
      inputClass: String,
      step: {
        type: Number,
        default: 1
      },
      isEditServOrder:{
        type:String
      }
    },
    computed: {
      inputStyleClass() {
        return this.inputClass ? `el-input-${this.inputClass}` : '';
      }
    },
    methods: {
      handleInput(value) {
        this.$emit('input', value);
      }
    }
  }
</script>
<style lang="scss" scoped>
  .input-form {
    width: 186px;
    height: auto;
    display: flex;
    align-items: center;
  }
  .input-box{
    position: relative;
  }
  .suffix-text{
    position: absolute;
    top: 10px;
    right: 50px;
    color: #ccc;
  }
  .el-input-factory{
    width: 20%;
    .input-form{
      width: 130px !important;
    }
  }
</style>
<style>
.input-box{
  .el-input-number .el-input__inner{
    text-align: left !important;
  }
}
</style>



// WEBPACK FOOTER //
// InputNumberField.vue?51315d34